import React, { useState, useEffect } from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from './ui/card';
import { Check } from 'lucide-react';
import { fetchServices } from '../lib/travelApi';
import { getServiceIcon } from '../lib/serviceIcons';

const Services = () => {
  const [content, setContent] = useState(null);

  useEffect(() => {
    fetchServices().then(setContent).catch(() => setContent(null));
  }, []);

  if (!content) return null;

  return (
    <section id="services" className="py-20 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            {content.heading}
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            {content.subheading}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-6xl mx-auto">
          {content.services.map((service, index) => {
            const Icon = getServiceIcon(service.icon);
            return (
              <Card
                key={index}
                className="hover:shadow-2xl transition-shadow duration-300 border-t-4 border-amber-600"
              >
                <CardHeader>
                  <div className="w-16 h-16 bg-amber-100 rounded-full flex items-center justify-center mb-4">
                    <Icon className="w-8 h-8 text-amber-600" />
                  </div>
                  <CardTitle className="text-2xl">{service.title}</CardTitle>
                  <CardDescription className="text-base">
                    {service.description}
                  </CardDescription>
                </CardHeader>
                <CardContent>
                  <ul className="space-y-3">
                    {service.features.map((feature, idx) => (
                      <li key={idx} className="flex items-start">
                        <Check className="w-5 h-5 text-amber-600 mr-2 flex-shrink-0 mt-0.5" />
                        <span className="text-gray-700">{feature}</span>
                      </li>
                    ))}
                  </ul>
                </CardContent>
              </Card>
            );
          })}
        </div>

        {/* USP Section */}
        {(content.usp_heading || content.usp_text || content.usp_badge) && (
          <div className="mt-20 bg-black text-white rounded-2xl p-12 max-w-5xl mx-auto">
            <div className="text-center">
              <h3 className="text-3xl md:text-4xl font-bold mb-6">
                {content.usp_heading}
              </h3>
              <p className="text-xl text-gray-300 mb-8">
                {content.usp_text}
              </p>
              {content.usp_badge && (
                <div className="inline-block bg-amber-600 text-white px-8 py-4 rounded-lg text-lg font-semibold">
                  {content.usp_badge}
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    </section>
  );
};

export default Services;
